<div class="container mx-auto px-4 py-6">
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-900">Reporte de Cartera Castigada</h1>
    <p class="text-gray-600 mt-1">Cuotas castigadas por retiros y aplazamientos</p>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-lg shadow-md p-6 mb-6">
    <form [formGroup]="filterForm" (ngSubmit)="loadReport()" class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
        <input 
          type="date" 
          formControlName="startDate"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
        <input 
          type="date" 
          formControlName="endDate"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Proyecto</label>
        <select 
          formControlName="projectId"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500">
          <option [ngValue]="null">Todos los proyectos</option>
          <option *ngFor="let p of projects" [ngValue]="p.id">{{ p.projectId }} - {{ p.name }}</option>
        </select>
      </div>
      <div class="flex items-end space-x-2">
        <button 
          type="submit" 
          [disabled]="isLoading"
          class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-400">
          <span *ngIf="isLoading">Cargando...</span>
          <span *ngIf="!isLoading">Buscar</span>
        </button>
        <button 
          type="button" 
          (click)="clearFilters()"
          class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
          Limpiar
        </button>
        <button 
          type="button" 
          (click)="downloadExcel()"
          [disabled]="isDownloading || reportData.length === 0"
          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400">
          <span *ngIf="isDownloading">Descargando...</span>
          <span *ngIf="!isDownloading">📥 Excel</span>
        </button>
      </div>
    </form>
  </div>

  <!-- My Reports Section -->
  <app-recent-report-jobs></app-recent-report-jobs>

  <!-- Estadísticas -->
  <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6" *ngIf="searchPerformed">
    <div class="bg-white rounded-lg shadow-md p-4">
      <div class="text-sm text-gray-500">Cuotas por Retiro</div>
      <div class="text-2xl font-bold text-red-600">{{ stats.totalWithdrawals }}</div>
    </div>
    <div class="bg-white rounded-lg shadow-md p-4">
      <div class="text-sm text-gray-500">Monto Retiros</div>
      <div class="text-2xl font-bold text-red-600">{{ stats.withdrawalsAmount | number:'1.2-2' }}</div>
    </div>
    <div class="bg-white rounded-lg shadow-md p-4">
      <div class="text-sm text-gray-500">Cuotas por Aplazamiento</div>
      <div class="text-2xl font-bold text-yellow-600">{{ stats.totalDeferrals }}</div>
    </div>
    <div class="bg-white rounded-lg shadow-md p-4">
      <div class="text-sm text-gray-500">Monto Aplazamientos</div>
      <div class="text-2xl font-bold text-yellow-600">{{ stats.deferralsAmount | number:'1.2-2' }}</div>
    </div>
    <div class="bg-white rounded-lg shadow-md p-4 border-2 border-gray-300">
      <div class="text-sm text-gray-500">Total Cartera Castigada</div>
      <div class="text-2xl font-bold text-gray-900">{{ stats.totalAmount | number:'1.2-2' }}</div>
    </div>
  </div>

  <!-- Tabla de resultados -->
  <div class="bg-white rounded-lg shadow-md overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200" *ngIf="reportData.length > 0">
        <thead class="bg-red-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Proyecto</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Tipo</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Pagador</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Documento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Cuota</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Vencimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Saldo</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Movimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-red-800 uppercase tracking-wider">Fecha Mov.</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of reportData" class="hover:bg-gray-50">
            <td class="px-4 py-3 text-sm">
              <div class="font-medium text-gray-900">{{ item.nemonico }}</div>
              <div class="text-xs text-gray-500">{{ item.proyecto }}</div>
            </td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ item.tipoInscripcion }}</td>
            <td class="px-4 py-3 text-sm">
              <div class="font-medium text-gray-900">{{ item.nombrePagador }}</div>
              <div class="text-xs text-gray-500">{{ item.tipoPagador }}</div>
            </td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ item.tipoDocumento }}: {{ item.numeroDocumento }}</td>
            <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ item.numeroCuota }}</td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ item.fechaVencimiento | date:'dd/MM/yyyy' }}</td>
            <td class="px-4 py-3 text-sm font-medium text-red-600">{{ item.moneda }} {{ item.saldoPendiente | number:'1.2-2' }}</td>
            <td class="px-4 py-3">
              <span class="px-2 py-1 text-xs rounded-full" [ngClass]="getMovementTypeClass(item.tipoMovimiento)">
                {{ item.tipoMovimientoDescripcion }}
              </span>
            </td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ item.fechaMovimiento | date:'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Estado vacío -->
      <div *ngIf="searchPerformed && reportData.length === 0 && !isLoading" class="text-center py-12">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h3 class="mt-2 text-sm font-medium text-gray-900">No hay cartera castigada</h3>
        <p class="mt-1 text-sm text-gray-500">No se encontraron cuotas castigadas con los filtros aplicados.</p>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoading" class="text-center py-12">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-red-600 mx-auto"></div>
        <p class="mt-2 text-sm text-gray-500">Cargando reporte...</p>
      </div>
    </div>
  </div>
</div>
